import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const companyRoutes: RouteObject[] = [
  {
    path: 'companies',
    lazy: page('CompanyListPage'),
    handle: {
      title: '내 업체',
      yearIndependent: true,
      feature: 'MULTI_COMPANY',
    } satisfies RouteHandle,
  },
  {
    path: 'companies/new',
    lazy: page('CompanyCreatePage'),
    // 고객사 등록·상세는 여러 업체를 관리하는 화면(판정·로드맵·캘린더 포함) — 기업 회원은 우리 회사(features/my-company)를 쓴다(specs/065 SC-004).
    handle: {
      title: '업체 등록',
      yearIndependent: true,
      feature: 'MULTI_COMPANY',
    } satisfies RouteHandle,
  },
  {
    path: 'companies/bulk',
    lazy: page('CompanyBulkRegisterPage'),
    handle: {
      title: '업체 일괄 등록',
      yearIndependent: true,
      feature: 'MULTI_COMPANY',
    } satisfies RouteHandle,
  },
  {
    path: 'companies/:id',
    lazy: page('CompanyDetailPage'),
    handle: { title: '업체 상세', feature: 'MULTI_COMPANY' } satisfies RouteHandle,
  },
];
